import React, { useState } from 'react';
import { Modal } from 'antd';
import { ButtonCommon, InputCommon, showAlertNotification } from 'components/common';
import { TransactionMethodCode } from 'models/TransactionMethod';
import { Bank, Money } from '@phosphor-icons/react';
import { useGetAllTransactionMethodsQuery, useUpdateSaleOrderMutation } from 'services';
import { ETransType } from 'models/Transaction';

interface AddExtraFeeModalProps {
  saleOrderId: string;
  isOpen: boolean;
  onCancel: () => void;
}
const AddExtraFeeModal: React.FC<AddExtraFeeModalProps> = ({ isOpen, onCancel, saleOrderId }) => {
  const [extraFee, setExtraFee] = useState<number>(0);
  const [transactionMethod, setTransactionMethod] = useState<TransactionMethodCode>('CASH');
  const { data: transactionMethodsData } = useGetAllTransactionMethodsQuery({
    query: {
      size: 'unlimited',
    },
  });
  const [updateSaleOrder, { isLoading }] = useUpdateSaleOrderMutation();
  const handleSubmit = async () => {
    if (extraFee > 0) {
      try {
        await updateSaleOrder({
          id: saleOrderId,
          transactions: [
            {
              transactionMethodId: transactionMethodsData?.data.rows.filter(
                (method) => method.code === transactionMethod,
              )?.[0].id,
              transactionAmount: extraFee,
              ownerType: 'CUSTOMER' as const,
              type: ETransType.OS_EXTRA_FEE,
            },
          ],
        });
        showAlertNotification({
          type: 'success',
          title: 'Thêm phụ phí thành công',
          message: 'Cập nhật đơn hàng và thêm phụ phí thành công.',
        });
        onCancel();
      } catch (error) {
        console.error('Error adding extra fee:', error);
        showAlertNotification({
          type: 'error',
          title: 'Thêm phụ phí thất bại',
          message: 'Đã có lỗi xảy ra khi thêm phụ phí. Vui lòng thử lại.',
        });
      }
    } else {
      showAlertNotification({
        type: 'warning',
        title: 'Phụ phí không hợp lệ',
        message: 'Vui lòng nhập số tiền phụ phí lớn hơn 0 trước khi xác nhận.',
      });
    }
  };
  const handleExtraFeeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value) || 0;
    setExtraFee(value);
  };

  return (
    <Modal
      open={isOpen}
      // onCancel={onCancel}
      footer={null}
      width={520}
      centered
      className='replace-version-modal'
      closeIcon={null}
      destroyOnClose={true}
    >
      <div className='bg-white rounded-lg flex flex-col overflow-hidden'>
        <div className='px-6 py-3'>
          <div className='text-black text-xl font-bold leading-normal mb-1'>THÊM PHỤ PHÍ</div>
          <div className='text-zinc-500 text-sm font-normal leading-tight'>
            Nhập số tiền phụ phí cần thêm vào đơn hàng
          </div>
        </div>
        <div className='px-10 py-3 bg-Background-Grey flex flex-col gap-3'>
          <div className=''>
            <div className='text-black text-sm font-medium leading-tight mb-2'>Phụ phí:</div>
            <InputCommon onChange={handleExtraFeeChange} value={extraFee} type='money' placeholder='Nhập số tiền' />
          </div>

          <div className=''>
            <div className='text-black text-sm font-medium leading-tight mb-2'>Phương thức thanh toán:</div>
            <div className='flex gap-3 mt-4'>
              <ButtonCommon
                color={transactionMethod === 'CASH' ? 'primary' : 'soft'}
                radius='rounded'
                className='!w-[50%] h-8'
                onClick={() => setTransactionMethod('CASH')}
                icon={<Money size={20} />}
              >
                Tiền mặt
              </ButtonCommon>

              <ButtonCommon
                color={transactionMethod === 'BANK_TRANSFER' ? 'primary' : 'soft'}
                radius='rounded'
                className='!w-[50%] h-8'
                onClick={() => setTransactionMethod('BANK_TRANSFER')}
                icon={<Bank size={20} />}
              >
                Chuyển khoản
              </ButtonCommon>
            </div>
          </div>
          <div className='flex justify-center gap-6 mt-3'>
            <ButtonCommon color='none' size='md' radius='rounded' onClick={onCancel}>
              Trở lại
            </ButtonCommon>
            <ButtonCommon
              color='primary'
              size='md'
              radius='rounded'
              onClick={handleSubmit}
              loading={isLoading}
              isDisabled={extraFee <= 0}
            >
              Xác nhận
            </ButtonCommon>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddExtraFeeModal;
